
const templateOnCreateCampaign = {    uuid_experimental_setup: '',
                                      uuid_design_space: '',
                                      uuid_objective: '',
                                      validated_experimental_setup: false,
                                      validated_design_space: false,
                                      validated_objective: false};

const templateOnUpdateCampaign = {    uuid_experimental_setup: '',
                                      uuid_design_space: '',
                                      uuid_objective: '',
                                      validated_experimental_setup: true,
                                      validated_design_space: true,
                                      validated_objective: true};

                                   
export function SetSessionInfo_OnDeleteCurrentProject(usr_session_ctx){

    let updatedSessionInfo = { ...usr_session_ctx.session_info };
    // Reset 'on_create_campaign' to the template state
    updatedSessionInfo.on_create_campaign = { ...templateOnCreateCampaign };
    updatedSessionInfo.on_update_campaign = { ...templateOnUpdateCampaign };
    // Clear 'uuid_current_project' field
    updatedSessionInfo.uuid_current_project = '';
    updatedSessionInfo.uuid_current_opt_campaign = '';
    return updatedSessionInfo

}


export function SetSessionInfo_OnMarkCurrentProject(usr_session_ctx, prj_uuid){

    let updatedSessionInfo = { ...usr_session_ctx.session_info };
    // Reset 'on_create_campaign' to the template state
    updatedSessionInfo.on_create_campaign = { ...templateOnCreateCampaign };
    updatedSessionInfo.on_update_campaign = { ...templateOnUpdateCampaign };
    // Clear 'uuid_current_project' field
    updatedSessionInfo.uuid_current_project = prj_uuid;
    updatedSessionInfo.uuid_current_opt_campaign = '';
    return updatedSessionInfo

}

export function SetSessionInfo_SetCampaignObjects(usr_session_ctx, 
                                                       uuid_exp_setup,
                                                       uuid_design_space, 
                                                       uuid_objective,
                                                       valid_exp_setup,
                                                       valid_design_space,
                                                       valid_objective){
    let updatedSessionInfo = {...usr_session_ctx.session_info}
    let updatedOnCreateCampaign = {...usr_session_ctx.session_info.on_create_campaign}
    // reset onCreateCampaign 
    updatedOnCreateCampaign = {...updatedOnCreateCampaign, uuid_experimental_setup: uuid_exp_setup}
    updatedOnCreateCampaign = {...updatedOnCreateCampaign, uuid_design_space: uuid_design_space}
    updatedOnCreateCampaign = {...updatedOnCreateCampaign, uuid_objective: uuid_objective}
    updatedOnCreateCampaign = {...updatedOnCreateCampaign, validated_experimental_setup: valid_exp_setup}
    updatedOnCreateCampaign = {...updatedOnCreateCampaign, validated_design_space: valid_design_space}
    updatedOnCreateCampaign = {...updatedOnCreateCampaign, validated_objective: valid_objective}
    updatedSessionInfo = {...updatedSessionInfo, on_create_campaign: updatedOnCreateCampaign}

    return updatedSessionInfo
}

export function SetSessionInfo_ResetCampaignObjects(usr_session_ctx, mark_current=false, uuid_opt_campaign=''){
    let updatedSessionInfo = { ...usr_session_ctx.session_info };
    // Reset 'on_create_campaign' to the template state
    updatedSessionInfo.on_create_campaign = { ...templateOnCreateCampaign };
    if (mark_current) {
        updatedSessionInfo.uuid_current_opt_campaign = uuid_opt_campaign;
    }

    return updatedSessionInfo
}


export function SetSessionInfo_OnMarkCurrentOptCampaign(usr_session_ctx, uuid_opt_campaign){

    let updatedSessionInfo = { ...usr_session_ctx.session_info };
    updatedSessionInfo.uuid_current_opt_campaign = uuid_opt_campaign;
    return updatedSessionInfo

}


export function SetSessionInfo_OnDeleteCurrentCampaign(usr_session_ctx){

    let updatedSessionInfo = { ...usr_session_ctx.session_info };
    // Reset 'on_create_campaign' to the template state
    // Clear 'uuid_current_project' field
    updatedSessionInfo.uuid_current_opt_campaign = '';
    // In case the current campaign that will be deleted was under update -> reset on_update_campaign
    updatedSessionInfo.on_update_campaign = { ...templateOnUpdateCampaign}
    return updatedSessionInfo
}


export function SetSessionInfo_ModifyCampaignObjects(usr_session_ctx, 
                                                     uuid_exp_setup,
                                                     uuid_design_space, 
                                                     uuid_objective,
                                                     valid_exp_setup,
                                                     valid_design_space,
                                                     valid_objective){
let updatedSessionInfo = {...usr_session_ctx.session_info}
let updatedOnUpdateCampaign = {...usr_session_ctx.session_info.on_update_campaign}
// reset onCreateCampaign 
updatedOnUpdateCampaign = {...updatedOnUpdateCampaign, uuid_experimental_setup: uuid_exp_setup}
updatedOnUpdateCampaign = {...updatedOnUpdateCampaign, uuid_design_space: uuid_design_space}
updatedOnUpdateCampaign = {...updatedOnUpdateCampaign, uuid_objective: uuid_objective}
updatedOnUpdateCampaign = {...updatedOnUpdateCampaign, validated_experimental_setup: valid_exp_setup}
updatedOnUpdateCampaign = {...updatedOnUpdateCampaign, validated_design_space: valid_design_space}
updatedOnUpdateCampaign = {...updatedOnUpdateCampaign, validated_objective: valid_objective}
updatedSessionInfo = {...updatedSessionInfo, on_update_campaign: updatedOnUpdateCampaign}

return updatedSessionInfo
}



export function SetSessionInfo_ResetModifyCampaignObjects(usr_session_ctx){
let updatedSessionInfo = {...usr_session_ctx.session_info}
updatedSessionInfo.on_update_campaign = { ...templateOnUpdateCampaign}
return updatedSessionInfo
}



